import { useNavigate, useLocation } from 'react-router-dom'
import './HomeworkPlan.css'

/**
 * Devoirs à faire / en retard — priorité scolaire dans le Suivi.
 * Réutilise les rows déjà calculées sur l’accueil (homeworkRows).
 */
function HomeworkPlan({ rows = [], maxItems = 5 }) {
  const navigate = useNavigate()
  const location = useLocation()
  const pending = (rows || []).filter(
    (r) => r.status === 'todo' || r.status === 'new' || r.status === 'overdue'
  )

  if (pending.length === 0) return null

  const visible = pending.slice(0, maxItems)

  return (
    <div className="homework-plan" id="suivi-homework">
      <p className="homework-plan-eyebrow">Devoirs</p>
      <p className="homework-plan-intro">
        Consignes de ton professeur — à traiter en priorité.
      </p>
      <ul className="homework-plan-list">
        {visible.map((row) => {
          const title =
            row.title ||
            row.exerciseTitle ||
            row.items?.[0]?.exerciseTitle ||
            'Devoir'
          const progress =
            row.totalCount > 0 ? `${row.doneCount || 0}/${row.totalCount}` : null
          const dueLabel = row.dueDate
            ? ` · échéance ${new Intl.DateTimeFormat('fr-FR', {
                day: 'numeric',
                month: 'short'
              }).format(row.dueDate instanceof Date ? row.dueDate : new Date(row.dueDate))}`
            : ''
          const exerciseId = row.targetExerciseId || row.exerciseId
          return (
            <li
              key={row.id || `${title}-${exerciseId}`}
              className={`homework-plan-item ${
                row.status === 'overdue' ? 'homework-plan-item--overdue' : ''
              }`}
            >
              <div className="homework-plan-item-main">
                <p className="homework-plan-item-title">{title}</p>
                <p className="homework-plan-item-meta">
                  {row.status === 'overdue' ? 'En retard' : 'À faire'}
                  {progress ? ` · ${progress}` : ''}
                  {dueLabel}
                </p>
              </div>
              {exerciseId ? (
                <button
                  type="button"
                  className="homework-plan-item-cta"
                  onClick={() => navigate(`/play/${exerciseId}`, { state: { returnTo: `${location.pathname}${location.search || ''}` } })}
                >
                  Faire
                </button>
              ) : null}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default HomeworkPlan
